"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const model_1 = __importDefault(require("../base/model"));
const permissions_schema_1 = require("./permissions.schema");
class Permissions extends model_1.default {
    getPermissionsList(roles) {
        const permissions = roles.reduce((arr, r) => {
            var _a;
            const rps = this.rolePermissions.find(rp => rp.roleName === r);
            arr.push(...((_a = rps === null || rps === void 0 ? void 0 : rps.permissions) !== null && _a !== void 0 ? _a : []));
            return arr;
        }, []);
        //unique array
        return [...new Set(permissions)];
    }
    getFeatureList(roles) {
        const features = roles.reduce((arr, r) => {
            var _a;
            const rps = this.rolePermissions.find(rp => rp.roleName === r);
            (_a = rps === null || rps === void 0 ? void 0 : rps.features) === null || _a === void 0 ? void 0 : _a.forEach(fe => {
                //Has feature been put into array already?
                const feature = arr.find(f => f.ID === fe.ID) || { ID: fe.ID };
                //Combine both subfeatures
                const subfeatures = [...(fe.subfeatures || []), ...(feature.subfeatures || [])];
                if (subfeatures.length) {
                    feature.subfeatures = subfeatures;
                }
                arr.push(feature);
            });
            return arr.sort((a, b) => a.ID.localeCompare(b.ID));
        }, []);
        //If admin just return
        const admin = features.find(f => f.ID === '*');
        if (admin)
            return [admin];
        //unique array
        return features.filter((f, i) => i === features.findIndex(fe => fe.ID === f.ID));
    }
    addNewPermissions(perms) {
        const invalidPerms = perms.find(rp => rp.permissions.find(p => !this.isValidPermission(p)));
        if (invalidPerms) {
            throw new Error('permissions are in the form resource.action');
        }
        this.rolePermissions = [
            ...this.rolePermissions,
            ...perms
        ];
    }
    isValidPermission(permission) {
        if (permission === '*')
            return true;
        const parts = permission.split('.');
        if (parts.length !== 2) {
            return false;
        }
        if (parts.findIndex(p => p.length === 0) > -1) {
            return false;
        }
        return true;
    }
    removeRole(roleName) {
        this.rolePermissions = this.rolePermissions.filter(rp => rp.roleName !== roleName);
    }
}
exports.default = Permissions;
Permissions.schema = permissions_schema_1.PermissionsSchema;
